
import { computed, defineComponent, ref } from 'vue'
// import EnIconVue from '../icon/swiper-en-icon.vue'
// import CnIconVue from '../icon/swiper-cn-icon.vue'
import EnIconVue from '@/views/icons/swiper-en-icon.vue'
import CnIconVue from '@/views/icons/swiper-cn-icon.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { loadLocale } from '@/api/locale'
export default defineComponent({
  name: 'Air8Header',
  components: { EnIconVue, CnIconVue },
  setup () {
    const { query } = useRoute()
    const store = useStore()
    const language = query.__ ? query.__ === 'CN' ? 'zh-CN' : 'en-US' : localStorage.getItem('_lang') || 'en-US'
    const locales:any = {}
    const lang = ref<string>(language)
    const isEnChange = computed(() => lang.value === 'en-US')

    localStorage.setItem('_lang', language)

    function toggleLanguage () {
      lang.value = lang.value === 'en-US' ? 'zh-CN' : 'en-US'
      localStorage.setItem('_lang', lang.value)
      store.commit('app/setLocale', locales[lang.value])
    }

    ['zh-CN', 'en-US'].forEach((l: any) => loadLocale(l).then((locale: any) => {
      locales[l] = locale
      l === lang.value && store.commit('app/setLocale', locale)
    }))

    return {
      isEnChange,
      toggleLanguage
    }
  }
})
